// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CsvJT4lFw5kiKLJjBt6E{flex-direction:column;display:flex}.AWVzx935y9cgH6HfjLen{border-radius:12px;min-height:276px;margin-bottom:32px;overflow:hidden}.AWVzx935y9cgH6HfjLen img{max-width:492px;display:block}.y_TLlhrb9Q9pdXlRXhkf{width:135px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `CsvJT4lFw5kiKLJjBt6E`,
	"emptyPreview": `AWVzx935y9cgH6HfjLen`,
	"helpGuideButton": `y_TLlhrb9Q9pdXlRXhkf`
};
export default ___CSS_LOADER_EXPORT___;
